//THIS NEEDS TO BE IN SYNC WITH THE API FILE!!!!!
export enum AdditionalExport {
  AttendanceAnalysisSubContractor = -1,
  AttendanceAnalysisCentre = -2,
  AttendanceAnalysisLearner = -3,
}
